export default function AccordionItem() {
  const accordionWrapper = document.querySelectorAll<HTMLDivElement>(".js-accordion-wrapper");

  accordionWrapper.forEach((wrapper) => {
    const allowMultiple = wrapper.getAttribute("data-allow-multiple");
    const accordionItems = wrapper.querySelectorAll<HTMLDivElement>(".js-accordion-item");
    let activeIndex = -1;

    if (accordionWrapper && accordionItems && accordionItems.length > 0) {
      const handleContentTabIndex = (isOpen: boolean, index: number) => {
        const accordionContent: HTMLDivElement | null = accordionItems[index].querySelector(".js-accordion-content");
        const buttonsAndLinks = accordionContent?.querySelectorAll("button, a");

        if (accordionContent && buttonsAndLinks && buttonsAndLinks.length > 0) {
          buttonsAndLinks.forEach((btn) => {
            if (isOpen) {
              btn.setAttribute("tabindex", "0");
            } else {
              btn.setAttribute("tabindex", "-1");
            }
          });
        }
      };

      const handleCloseAllItems = () => {
        accordionItems.forEach((item, index) => {
          const accordionBtn: HTMLButtonElement | null = item.querySelector(".js-accordion-btn");
          const accordionBtnIcon: HTMLSpanElement | null = item.querySelector(".js-icon");
          const accordionContentWrapper: HTMLDivElement | null = item.querySelector(".js-accordion-content-wrapper");
          const accordionContent: HTMLDivElement | null = item.querySelector(".js-accordion-content");

          if (index !== activeIndex && accordionBtn && accordionContent && accordionContentWrapper && accordionBtnIcon) {
            accordionBtn.setAttribute("aria-expanded", "false");
            accordionContentWrapper.style.maxHeight = "";
            accordionBtnIcon.style.transform = "rotate(180deg)";
            handleContentTabIndex(false, index);
          }
        });
      };

      accordionItems.forEach((item, index) => {
        const accordionBtn: HTMLButtonElement | null = item.querySelector(".js-accordion-btn");
        const accordionBtnIcon: HTMLSpanElement | null = item.querySelector(".js-icon");
        const accordionContentWrapper: HTMLDivElement | null = item.querySelector(".js-accordion-content-wrapper");
        const accordionContent: HTMLDivElement | null = item.querySelector(".js-accordion-content");
        let maxHeight = 0;

        const handleResize = () => {
          if (accordionBtn?.getAttribute("aria-expanded") === "true" && accordionContent && accordionContentWrapper) {
            maxHeight += accordionContent.clientHeight;
            accordionContentWrapper.style.maxHeight = `${maxHeight}px`;
          }
        };

        const handleToggleMenu = () => {
          if (allowMultiple?.toLowerCase() === "false") {
            activeIndex = index;
            handleCloseAllItems();
          }

          let isOpen = accordionBtn?.getAttribute("aria-expanded")?.toLowerCase() === "true" ? false : true;

          if (accordionBtn && accordionContent && accordionContentWrapper && accordionBtnIcon) {
            accordionBtn.setAttribute("aria-expanded", `${isOpen}`);

            if (isOpen) {
              maxHeight += accordionContent.clientHeight;
              accordionContentWrapper.style.maxHeight = `${maxHeight}px`;
              accordionBtnIcon.style.transform = "rotate(0deg)";
            } else {
              accordionContentWrapper.style.maxHeight = "";
              accordionBtnIcon.style.transform = "rotate(180deg)";
            }

            handleContentTabIndex(isOpen, index);
          }
        };

        if (accordionBtn) {
          accordionBtn.addEventListener("click", handleToggleMenu);
          window.addEventListener("resize", handleResize);
        }

        // sets hidden tab index to -1 by default
        handleContentTabIndex(false, index);
      });
    }
  });
}
